import { setTerm } from './helpers';

export const setPosessor = setTerm('suburban_offer_filter');
